//Login
export const POST_FAKE_LOGIN = "/auth-login";

//Register
export const POST_FAKE_REGISTER = "/register";